import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Initialize any analytics or tracking scripts here
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
       
        <div className="cookie-text">
          <p>Diese Website verwendet Cookies, um Ihnen einen besseren Service zu bieten. <Link to="/datenschutz">Mehr erfahren</Link></p>
        </div>
        <div className="cookie-buttons">
          <button onClick={handleDecline} className="btn btn-outline">Ablehnen</button>
          <button onClick={handleAccept} className="btn btn-primary">Akzeptieren</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
